import React from "react";

import { useFieldArray } from "react-hook-form-7";

import { Box, Stack } from "@chakra-ui/react";

import { ReportFragment } from '../../../../graphql/generated/definitions';
import {
  SectionFormMethods,
  SectionWithAnswers,
} from "../../types/ReportFormTypes";

import QuestionFormDispatch from "../questions/QuestionFormDispatch";
import SectionTitle from "./utils/SectionTitle";

type SectionFormProps = SectionFormMethods & {
  report: ReportFragment;
  section: SectionWithAnswers;
  path: `sections.${number}`;
  sectionIndex: number;
  children?: React.ReactNode | React.ReactNode[];
};

const SectionForm: React.FC<SectionFormProps> = ({
  report,
  section,
  sectionIndex,
  path,
  control,
  children,
  ...formMethods
}) => {
  const { fields: answerFields, ...fieldArrayMethods } = useFieldArray({
    control,
    name: `${path}.answers` as `sections.0.answers`,
    keyName: "_questionFieldId",
  });

  return (
    <Box as="section" aria-labelledby={`${section.id}.title`} aria-describedby={`${section.id}.description`}>
      <Box className="page-break" />
      <Box>
        <SectionTitle section={section} sectionIndex={sectionIndex} />
      </Box>
      <Stack spacing={["10", "16"]} pt={["10", "16"]}>
        {answerFields.map((answerField, index) => (
          <QuestionFormDispatch  
            key={answerField._questionFieldId}
            report={report}
            question={section.questions[index]}
            path={`${path}.answers.${index}` as const}
            sectionIndex={sectionIndex}
            questionIndex={index}
            {...{ ...formMethods, control, ...fieldArrayMethods }}
          />
        ))}
        {children}
      </Stack>
    </Box>
  );
};

export default React.memo(SectionForm);
